import React from 'react';
import './QuizScore.css';

interface QuizScoreProps {
  score: number;
  totalQuestions: number;
  currentQuestion: number;
}

const QuizScore: React.FC<QuizScoreProps> = ({ score, totalQuestions, currentQuestion }) => {
  const percentage = Math.round((score / totalQuestions) * 100);
  

  const getScoreColor = () => {
    if (percentage >= 80) return "#4facfe";
    if (percentage >= 60) return "#f093fb";
    return "#ff6b6b";
  };

  return (
    <div className="score-container">
      <div className="score-header">
        <h3>Tvoj napredek</h3>
        <div className="score-display">
          <span className="current-score">{score}</span>
          <span className="total-score">/{totalQuestions}</span>
        </div>
      </div>
      
      <div className="progress-bar-container">
        <div 
          className="progress-bar"
          style={{ 
            width: `${(currentQuestion / totalQuestions) * 100}%`,
            backgroundColor: getScoreColor()
          }}
        />
      </div>
      
      <div className="question-counter">
        Vprašanje {currentQuestion} od {totalQuestions}
      </div>     
    </div>
  );
};

export default QuizScore;

